export function getDaysDifference(date1, date2) {
  // Asegurarse de que las entradas sean objetos Date
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Resetear la hora a medianoche para calcular la diferencia solo en días
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);

  //const diffTime = Math.abs(d2.getTime() - d1.getTime());
  const diffTime = d2.getTime() - d1.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

// Función auxiliar para calcular info del cumpleaños
export const calculateBirthdayInfo = (birthdayStr) => {
  if (!birthdayStr) return { daysUntilBirthday: null, isBirthdayToday: false };

  const today = new Date();
  const birthDate = new Date(birthdayStr + 'T00:00:00'); // T00:00:00 evita desfases de zona horaria
  let birthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());

  const daysUntilBirthday = getDaysDifference(new Date(), birthday);
  const birthdayWeek = daysUntilBirthday > -8 && daysUntilBirthday < 1;
  return { birthdayWeek: birthdayWeek, isBirthdayToday: daysUntilBirthday === 0 };
};